<lgb-hero-binder [admin]="admin()" [uBinder]="uBinder()" [binder]="binder()" [fullWidth]="true"></lgb-hero-binder>
<p class="title-sticky title-xs font-serra mb-4">Coup d'oeil</p>
<div class="overview-container mb-4">
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-regular fa-cards-blank"></i>
		<div>
			<div class="overview-title">
				Cartes :
			</div>
			{{cards()?.length}}
		</div>
	</div>
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-regular fa-grid-2-plus"></i>
		<div>
			<div class="overview-title">
				Capacité :
			</div>
			{{capacity()}}
		</div>
	</div>
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-regular fa-clone"></i>
		<div>
			<div class="overview-title">
				Doublons :
			</div>
			{{getNbDoubles()}}
		</div>
	</div>
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-regular fa-stars"></i>
		<div>
			<div class="overview-title">
				Rareté :
			</div>
			<lgb-rate [rate]="rarityAvg()"></lgb-rate>
		</div>
	</div>
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-light fa-hand-sparkles"></i>
		<div>
			<div class="overview-title">
				Etat :
			</div>
			<lgb-rate [rate]="condAvg()"></lgb-rate>
		</div>
	</div>
	<div class="overview-item">
		<i class="badge badge-soft badge-primary fa-regular fa-piggy-bank"></i>
		<div>
			<div class="overview-title">
				Valeur :
			</div>
			{{uBinder()?.amount | number:'1.0-0':'fr-FR' }}€
		</div>
	</div>
</div>